import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TABLE_THEME, TableTheme } from '../../types/table-theme.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-data',
  standalone: true,
  imports: [],
  host: { "[style.width.px]": "width()" },
  templateUrl: './table-data.component.html',
  styleUrl: './table-data.component.scss'
})
export class TableDataComponent {
  private _theme: TableTheme = inject(TABLE_THEME);

  public width: InputSignal<number> = input<number>(this._theme.defaultColumnWidth);

  public isFixed: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
}
